// Общие форматтеры для админки. Раньше каждая страница имела
// свою копию dt() — теперь одна.

export function dt(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Дата без времени (используется на страницах юзеров/доступов где время не важно).
export function date(iso: string): string {
  return new Date(iso).toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

// Целое с разделителем тысяч по-русски.
export function num(n: number | null | undefined): string {
  if (n == null) return "—";
  return n.toLocaleString("ru-RU");
}

// Процент заполнения с clip 0..100.
export function fillPct(active: number, max: number): number {
  if (max <= 0) return 0;
  return Math.min(100, Math.round((active / max) * 100));
}
